import { render, staticRenderFns } from "./SubjectAchievement.vue?vue&type=template&id=98b0e0f0&scoped=true&lang=pug&"
import script from "./SubjectAchievement.vue?vue&type=script&lang=ts&"
export * from "./SubjectAchievement.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectAchievement.vue?vue&type=style&index=0&id=98b0e0f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b0e0f0",
  null
  
)

export default component.exports